import script from "./SecondBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondBlock.vue?vue&type=script&setup=true&lang=js"

import "./SecondBlock.vue?vue&type=style&index=0&id=387d532a&lang=scss"

const __exports__ = script;

export default __exports__